<template>
  <div class="item-row-quote-builder-parts quote-builder-item-row type-part"
    :id="item.quoteItemId"
    :class="[{'is-selected' : isSelected, 'is-open' : isSelected && !isFullWidth}, `quote-builder-item-${$theme.name}`, defaultRowColourClass(item, getItemAssessments(item), false), rowDisplayStatus(item, getItemAssessments(item))]">
    <div @click="event => handleClick(event)">
      <!--------------------------------------------------------------- Main Grid --------------------------------------->
      <quote-builder-part-item-template :is-full-width="isFullWidth"
        :is-header="false"
        :is-fully-expanded="isSelected && !isFullWidth"
        @handleClick="handleClick">
        <!------- Description / partnumber ------->
        <template v-slot:description>

          <item-description-autocomplete v-if="isSelected && !item.deleteOtherItem && !readOnlyView && !audanetLock && $company.setting.itemAutoCompleteEnabled && !isItemRemoved(item, getItemAssessments(item))"
            v-model="item.itemDesc"
            v-focus-next:callback="handleTransitionNextRow"
            v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
            :placeholder="'Item Description'"
            :id="item.quoteItemId + '-itemDesc'"
            :schedule-id="vehicle.scheduleId"
            :body-id="vehicle.bodyId"
            :class-prop="(!isValidItemDesc(item.quoteItemId) ? 'is-danger ': '') + defaultRowColourClass(item, getItemAssessments(item))"
            :item-type="ItemTypes.PARTS"
            :times-style="labourType" />

          <input v-else-if="isSelected && !item.deleteOtherItem && !readOnlyView && !audanetLock && !$company.setting.itemAutoCompleteEnabled && !isItemRemoved(item, getItemAssessments(item))"
            class="input"
            :id="item.quoteItemId + '-itemDesc'"
            :class="[defaultRowColourClass(item, getItemAssessments(item)), !isValidItemDesc(item.quoteItemId) ? 'is-danger': '']"
            placeholder="Item Description"
            v-focus-next:callback="handleTransitionNextRow"
            v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
            v-focus-inserted="{ focus: $userInfo.scrollItemPart }"
            :disabled="item.deleteOtherItem"
            v-model="item.itemDesc">

          <span v-else
            :id="item.quoteItemId + '-itemDesc'"
            class="is-quote-item-field-editable pl-2"
            :class="{'has-text-danger' : !isValidItemDesc(item.quoteItemId)}">
            {{ item.itemDesc || 'Item Description' }}
          </span>

          <input class="input is-uppercase"
            v-if="isSelected"
            :id="item.quoteItemId + '-itemNo'"
            :class="defaultRowColourClass(item)"
            placeholder="Part No."
            maxlength="24"
            v-focus-next:callback="handleTransitionNextRow"
            v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
            :disabled="item.deleteOtherItem || readOnlyComputed"
            v-model="item.partNo">
          <span v-else
            :id="item.quoteItemId + '-itemNo'"
            :class="!item.partNo ? 'has-text-grey-light' : ''"
            class="is-italic is-quote-item-field-editable pl-2">
            {{ item.partNo || 'Part No.' }}
          </span>

        </template>

        <!-------------------Report ------------>
        <template v-slot:report>
          <div class="is-clickable mt-1"
            :class="{'disabled' : item.deleteOtherItem || !canMakeReportOnly(item)}"
            @click="$event => updateReport(item, $event)">
            <div class="is-flex ">
              <span v-tippy="{ theme: 'secondary', enabled: true }"
                content="Report"
                :class="item.reportOnly ? 'is-dark is-danger' : 'is-white'"
                class="tag p-1 px-2">R
              </span>
            </div>
          </div>
        </template>

        <!------------------- Type ------------>
        <template v-slot:part_type>
          <div class="is-flex is-justify-content-center">
            <div v-if="isSelected && !item.deleteOtherItem && !readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
              class="select">
              <select v-model="item.mark"
                :class="defaultRowColourClass(item, getItemAssessments(item))"
                :disabled="item.deleteOtherItem"
                v-focus-next:callback="handleTransitionNextRow"
                @change="onPartConditionChange(item)">
                <option v-for="(typeObject, type) in partTypes"
                  :value="typeObject.value"
                  :key="typeObject.value"
                  :title="typeObject.description">{{ $filters.formatPartCondition(type) }}</option>
              </select>
            </div>
            <span class="mt-1"
              v-else>{{ $filters.formatPartType(item.mark) }}</span>
          </div>
        </template>

        <!----------------- Quantity --------->
        <template v-slot:part_qty>
          <div :class="[defaultCellColourClass(item,'itemQuantity')]">

            <vue-numeric v-if="isSelected && !readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
              class="input has-text-right"
              :class="defaultRowColourClass(item, getItemAssessments(item))"
              v-model.number="item.itemQuantity"
              v-focus-next:callback="handleTransitionNextRow"
              v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
              :id="item.quoteItemId + '-qty'"
              :minus="subQuoteNo !== 0"
              :precision="0"
              @input="updateValue(index, item)" />
            <span v-else
              class="is-quote-item-field-editable end mt-1"
              :id="item.quoteItemId + '-qty'">{{ item.itemQuantity }}</span>
          </div>
        </template>

        <!-- buy price -->
        <template v-slot:part_buy>
          <div class="cell is-col-span-3">
            <vue-numeric v-if="isSelected && !item.deleteOtherItem && !readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
              class="input has-text-right"
              @input.native="handleOnPriceChange(item)"
              :class="defaultRowColourClass(item, getItemAssessments(item))"
              v-model.number="item.buyPrice"
              v-focus-next:callback="handleTransitionNextRow"
              v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
              :min="0"
              :id="item.quoteItemId + '-buy'"
              :disabled="item.deleteOtherItem || (item.quantityReceived>0 && !$userInfo.isSupportUser)"
              :precision="2" />
            <span v-else
              class="is-quote-item-field-editable end"
              :id="item.quoteItemId + '-buy'">{{ $filters.formatCurrency(item.buyPrice, $userInfo.locale, 2) }}</span>
          </div>
        </template>

        <!-- markup price -->
        <template v-slot:part_markup>
          <div class="cell is-col-span-3">
            <vue-numeric v-if="isSelected && !item.deleteOtherItem && !readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
              class="input has-text-right"
              :id="item.quoteItemId + '-markup'"
              :class="defaultRowColourClass(item, getItemAssessments(item))"
              v-model.number="item.markupValue"
              v-focus-next:callback="handleTransitionNextRow"
              v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
              @input.native="handleOnPriceChange(item)"
              :minus="true"
              :precision="2"
              :disabled="item.deleteOtherItem"
              @input="updateTotal()" />
            <span v-else
              class="is-quote-item-field-editable end mt-1"
              :id="item.quoteItemId + '-markup'">{{ $filters.formatCurrency(item.markupValue, $userInfo.locale, 2) }}</span>
          </div>
        </template>

        <!-- unit price -->
        <template v-slot:part_sell>
          <div class="cell is-col-span-3">
            <vue-numeric v-if="isSelected && !readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
              class="input has-text-right"
              :class="defaultRowColourClass(item, getItemAssessments(item))"
              v-model.number="item.value"
              v-focus-next:callback="handleTransitionNextRow"
              v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
              @input.native="handleOnPriceChange(item)"
              :minus="true"
              :id="item.quoteItemId + '-unit'"
              :precision="2"
              @input="updateMarkup(index, item)" />
            <span v-else
              class="is-quote-item-field-editable end"
              :id="item.quoteItemId + '-unit'">
              {{ $filters.formatCurrency(item.value, $userInfo.locale, 2) }}
            </span>
          </div>
        </template>

        <template v-slot:total_value>
          <div class="is-flex is-justify-content-end"
            :class="{'has-text-danger': item.markupValue * item.itemQuantity == 0 || !(item.markupValue * item.itemQuantity)}">
            <span class="is-quote-item-field-editable mt-1"
              :id="item.quoteItemId + '-total-val'">
              {{ $filters.formatCurrency( item.markupValue * item.itemQuantity, $userInfo.locale, false, 2) }}
            </span>
          </div>
        </template>

        <!---------------------- Comment   ---------------->
        <template v-slot:comment
          v-if="item.itemComment">
          <div v-tippy="{ theme: 'secondary', enabled: true, content:item.itemComment }">
            <span class="mdi has-text-primary is-primary mdi-18px mdi-message-reply-text mr-1 is-clickable" />
          </div>
        </template>

        <template v-slot:assessment_status>
          <supplementary-icon v-if="showAssessment"
            :item="item"
            :item-assessments="getItemAssessments(item)"
            :next-assessment-number="nextSupplemetryNo"
            :quoting-method="quotingMethod"
            :icon-size="4"
            class="icon" />
        </template>

        <template v-slot:part_status>
          <button class="button is-ghost is-small tooltip px-0 mx-1"
            :data-tooltip="getPartStatus(item)?.title"
            @click="(e) => $emit('goToPartsCheck', e, item.partsCheckReferenceNo, 'quote', item)">
            <span :class="[getPartStatus(item)?.classStatus]" />
            <label />
          </button>
        </template>

        <template v-slot:delete_button>
          <button class="button is-ghost is-small tooltip px-0 has-text-grey-lighter"
            data-tooltip="Delete"
            @click="$emit('deleteItem', item)"
            :disabled="readOnlyComputed">
            <span class="material-symbols-rounded "
              :class="{'is-clickable' : !readOnlyComputed}"
              @mouseenter="$event.target.classList.add('has-text-danger')"
              @mouseleave="$event.target.classList.remove('has-text-danger')">
              delete
            </span>
          </button>
        </template>

        <template v-slot:drag_button>
          <button class="button is-ghost is-small tooltip item-drag-handle has-text-grey-light px-0"
            data-tooltip="Drag"
            :disabled="readOnlyComputed">
            <span class="mdi mdi-drag-vertical mdi-24px"
              :class="{'is-clickable' : !readOnlyComputed}" />
          </button>
        </template>

        <!-------------------------- Line Numer  --------------->
        <template v-slot:lineNo>
          <div v-tippy="{ theme: 'secondary', enabled: true, content: 'Line Number' }">
            <vue-numeric v-if="$userInfo.isSupportUser && !readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
              class="input has-text-right"
              :class="defaultRowColourClass(item, getItemAssessments(item))"
              v-model.number="item.lineNumber"
              v-focus-next:callback="handleTransitionNextRow"
              :precision="0"
              separator="" />
            <span v-else>{{ item.lineNumber }}</span>
          </div>
        </template>

        <!---------------------------- Item No  ----------------->
        <template v-slot:itemNo>
          <div v-tippy="{ theme: 'secondary', enabled: true, content: 'Item Number' }">
            <input v-if="!item.deleteOtherItem && !readOnlyView && !audanetLock && !isItemRemoved(item, getItemAssessments(item))"
              class="input"
              :class="[defaultRowColourClass(item, getItemAssessments(item)), !isValidItemNo(item.quoteItemId) ? 'is-danger': '']"
              placeholder="Item No."
              :disabled="item.deleteOtherItem"
              v-model="item.itemNo"
              v-focus-next:callback="handleTransitionNextRow">
            <span v-else>{{ item.itemNo }}</span>
          </div>
        </template>

        <!----------------- Item Status ----------------->
        <template v-slot:itemStatus>
          <div v-tippy="{ theme: 'secondary', enabled: true, content: 'Item Status' }">
            <input v-if="!readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
              class="input is-capitalized"
              v-model="item.itemStatus"
              v-focus-next:callback="handleTransitionNextRow">
            <span v-else>{{ item.itemStatus }}</span>
          </div>
        </template>

      </quote-builder-part-item-template>
    </div>

  </div>

</template>

<script>
import vueNumeric from '@/components/VueNumeric/vue-numeric.vue'
import { PartStatusTypes, PartTypes, ItemTypes, QuoteItemsOrderStatusTypes } from '@/enums'
import QuoteBuilderPartItemTemplate from '../../templates/QuoteBuilderPartItemTemplate.vue'
import ItemDescriptionAutocomplete from '../../../components/ItemDescriptionAutocomplete/ItemDescriptionAutocomplete.vue'
import { QuotePartMixin, QuoteItemValidationMixin, QuoteItemsMixin, QuoteAssessmentMixin, QuoteItemDifferenceMixin } from '@/views/quote/quoteBuilder/mixins'
import supplementaryIcon from '@/views/quote/components/SupplementaryIcon.vue'
import { FocusNext, FocusNextElementOnArrowDirective } from '@/components/directives'

export default {
  name: 'QuoteBuilderPartItem',
  directives: { FocusNext, FocusNextElementOnArrowDirective },
  components: { supplementaryIcon, ItemDescriptionAutocomplete, vueNumeric, QuoteBuilderPartItemTemplate },
  mixins: [QuoteItemValidationMixin, QuoteItemsMixin, QuoteAssessmentMixin, QuoteItemDifferenceMixin, QuotePartMixin],
  props: {
    index: {
      type: Number,
      default: 0
    },
    labourType: {
      type: String,
      required: true
    },
    innerValue: {
      type: Object,
      required: true
    },
    // in a single row view, the row is full width
    isFullWidth: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    nextLineNumber: {
      type: Number,
      default: 0
    },
    readOnlyView: {
      type: Boolean,
      default: false
    },
    subQuoteNo: {
      type: Number,
      default: 0
    },
    quotingMethod: {
      type: String,
      required: true
    },
    audanetLock: {
      type: Boolean,
      default: false
    },
    vehicle: {
      type: Object,
      required: true
    },
    itemsAssessments: {
      type: Array,
      default: () => []
    },
    showAssessment: {
      type: Boolean,
      default: false
    },
    nextSupplemetryNo: {
      type: Number
    },
    ormObject: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      displayDeleted: false,
      itemType: ItemTypes.PARTS,
      isFloatingWidgetActive: false
    }
  },
  computed: {
    PartStatusTypes() {
      return PartStatusTypes
    },
    partTypes() {
      return PartTypes
    },
    ItemTypes() {
      return ItemTypes
    },
    QuoteItemsOrderStatusTypes() {
      return QuoteItemsOrderStatusTypes
    },
    readOnlyComputed() {
      return this.innerValue.readOnly || !this.isEditable
    }
  },
  methods: {
    handleArrowKeys(currentIndex, nextIndex, fieldId, isArrowDown) {
      this.$eventHub.$emit('handleArrowKeyFocus', currentIndex, nextIndex, fieldId, this.item, isArrowDown)
    },
    handleTransitionNextRow() {
      this.$emit('focusNextRow')
    },
    handleOnPriceChange(item) {
      if (item.partStatus === PartStatusTypes.sentManualEnquiry) {
        item.partStatus = PartStatusTypes.pricedPartsControlManual
      }
    },
    closeModal() {
      this.isPresentAsModalActive = false
    },
    handleClick(event, close = false) {
      event.stopPropagation()
      this.$emit('itemRowClicked', this.item, event, close)
    },
    updateReport(item) {
      if (this.canMakeReportOnly(item) && !this.readOnlyComputed) {
        if (!this.itemSnapshot) this.captureItemSnapshot()
        item.reportOnly = !item.reportOnly
        this.updateTotal()
      }
    },

    getItemAssessments(item) {
      const assessments = this.itemsAssessments
      const itemAssessments = assessments.find((i) => i.quoteItemId == item.quoteItemId)
      if (!!itemAssessments) return itemAssessments.assessments
      return []
    },
    updateTotal() {
      this.isFloatingWidgetActive = true
    },
    getPartStatus(part) {
      let statusObj = {
        class: '',
        title: ''
      }
      if (!part.partStatus && part.quantityOrdered == 0 && part.quantityReceived == 0) {
        statusObj = QuoteItemsOrderStatusTypes.NotRequested
      } else if (part.partStatus === PartStatusTypes.sentManualEnquiry && part.quantityOrdered == 0 && part.quantityReceived == 0) {
        statusObj = QuoteItemsOrderStatusTypes.Requested
      } else if (part.partStatus === PartStatusTypes.pricedPartsControlManual && part.quantityOrdered == 0 && part.quantityReceived == 0) {
        statusObj = QuoteItemsOrderStatusTypes.Priced
      } else if (part.partStatus === 'Exp' && part.quantityOrdered == 0 && part.quantityReceived == 0) {
        statusObj = QuoteItemsOrderStatusTypes.Requested
      } else if (part.partStatus === 'Imp' && part.quantityOrdered == 0 && part.quantityReceived == 0) {
        statusObj = QuoteItemsOrderStatusTypes.Priced
      } else if (part.partStatus === 'Pord' && part.quantityOrdered == 0 && part.quantityReceived == 0) {
        statusObj = QuoteItemsOrderStatusTypes.PendingOrder
      } else if (
        (part.quantityOrdered > 0 && part.quantityReceived == 0 && part.quantityReturned == 0) ||
        (part.quantityOrdered > part.quantityReturned && part.quantityReceived == 0)
      ) {
        statusObj = QuoteItemsOrderStatusTypes.ItemOrdered
      } else if (part.quantityOrdered > 0 && part.quantityReturned > 0 && part.quantityOrdered > part.quantityReturned) {
        statusObj = QuoteItemsOrderStatusTypes.PartiallyReturned
      } else if (part.quantityOrdered > 0 && part.quantityReturned > 0 && part.quantityOrdered == part.quantityReturned) {
        statusObj = QuoteItemsOrderStatusTypes.AllItemsReturned
      } else if (part.quantityOrdered > 0 && part.quantityReceived > 0 && part.quantityOrdered == part.quantityReceived) {
        statusObj = QuoteItemsOrderStatusTypes.FullyReceived
      } else if (part.quantityOrdered > 0 && part.quantityReceived > 0 && part.quantityOrdered !== part.quantityReceived) {
        statusObj = QuoteItemsOrderStatusTypes.PartiallyReceived
      }
      return {
        classStatus: statusObj.class,
        title: statusObj.title
      }
    },

    captureItemSnapshot() {
      const i = this.item
      this.itemSnapshot = {
        itemDesc: i.itemDesc,
        partNo: i.partNo,
        itemQuantity: i.itemQuantity,
        buyPrice: i.buyPrice,
        markupValue: i.markupValue,
        value: i.value,
        mark: i.mark,
        reportOnly: i.reportOnly,
        lineNumber: i.lineNumber,
        itemNo: i.itemNo,
        itemStatus: i.itemStatus,
        presentAs: JSON.stringify(i.presentAs)
      }
    },
    isItemDirty() {
      if (!this.itemSnapshot) return false
      const i = this.item
      return (
        i.itemDesc !== this.itemSnapshot.itemDesc ||
        i.partNo !== this.itemSnapshot.partNo ||
        i.itemQuantity !== this.itemSnapshot.itemQuantity ||
        i.buyPrice !== this.itemSnapshot.buyPrice ||
        i.markupValue !== this.itemSnapshot.markupValue ||
        i.value !== this.itemSnapshot.value ||
        i.mark !== this.itemSnapshot.mark ||
        i.reportOnly !== this.itemSnapshot.reportOnly ||
        i.lineNumber !== this.itemSnapshot.lineNumber ||
        i.itemNo !== this.itemSnapshot.itemNo ||
        i.itemStatus !== this.itemSnapshot.itemStatus ||
        JSON.stringify(i.presentAs) !== this.itemSnapshot.presentAs
      )
    },
    canMakeReportOnly(item) {
      const assessments = this.getItemAssessments(item)
      if (assessments.length > 0) {
        const lastAssessment = assessments[assessments.length - 1]
        const lastValues = lastAssessment[lastAssessment.length - 1]
        if (!lastValues.reportOnly) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss">
@use "@/assets/style/override-colours" as oc;

.item-row-quote-builder-parts {
  height: 55px !important;
  // border: 1px solid #adb5bd;
  border-radius: 5px;
  font-size: 0.9em;
  margin-bottom: 5px;
  padding: 2px;

  .center-y {
    display: flex;
    align-items: center;
  }

  .center {
    display: flex;
    justify-content: center;
  }
  .end {
    display: flex;
    justify-content: flex-end;
  }

  &.is-selected {
    height: 85px !important;
  }

  &.is-open {
    height: 120px !important;
  }
}

/* text overflow ellipses */
.item-row-quote-builder-parts span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>